/*
 * @Description: 市场准入管理 - 路由
 * @Date: 2026-08-31
 */
import type { RouteRecordRaw } from 'vue-router';

/**
 * 角色路由前缀（参考 contract-mgmt 多角色模式）
 * 工业端 = industry，服务商端 = asp（服务商 = ASP 角色）
 */
const INDUSTRY = 'industry';
const ASP = 'asp';

/**
 * 工业端路由（顶部菜单，无左侧菜单）
 */
const industryRoutes: RouteRecordRaw[] = [
  {
    path: `/main/${INDUSTRY}/market-access-mgmt/list`,
    name: 'market-access-mgmt-industry-list',
    meta: { title: '准入管理', roleText: INDUSTRY },
    component: () => import('../views/i-access-list.vue')
  },
  {
    path: `/main/${INDUSTRY}/market-access-mgmt/template`,
    name: 'market-access-mgmt-industry-template',
    meta: {
      title: '准入材料模板',
      roleText: INDUSTRY,
      parentPath: `/main/${INDUSTRY}/market-access-mgmt/list`
    },
    component: () => import('../views/i-template.vue')
  },
  {
    path: `/main/${INDUSTRY}/market-access-mgmt/template-create`,
    name: 'market-access-mgmt-industry-template-create',
    meta: {
      title: '新建准入模板',
      roleText: INDUSTRY,
      mode: 'create',
      parentPath: `/main/${INDUSTRY}/market-access-mgmt/list`
    },
    component: () => import('../views/i-template-editor.vue')
  },
  {
    path: `/main/${INDUSTRY}/market-access-mgmt/template-edit`,
    name: 'market-access-mgmt-industry-template-edit',
    meta: {
      title: '编辑准入模板',
      roleText: INDUSTRY,
      mode: 'edit',
      parentPath: `/main/${INDUSTRY}/market-access-mgmt/list`
    },
    component: () => import('../views/i-template-editor.vue')
  }
];

/**
 * 服务商端路由（顶部菜单，无左侧菜单）
 */
const aspRoutes: RouteRecordRaw[] = [
  {
    path: `/main/${ASP}/market-access-mgmt/list`,
    name: 'market-access-mgmt-asp-list',
    meta: { title: '工业准入列表', roleText: ASP },
    component: () => import('../views/a-access-list.vue')
  }
];

/**
 * PC 答题路由（服务商准入申请，独立登录，无菜单）
 */
const pcRoutes: RouteRecordRaw[] = [
  {
    path: '/market-access-mgmt/pc-register',
    name: 'market-access-mgmt-pc-register',
    meta: { title: '注册账号', noLayout: true },
    component: () => import('../views/pc-register.vue')
  },
  {
    path: '/market-access-mgmt/pc-submit-material',
    name: 'market-access-mgmt-pc-submit-material',
    meta: { title: '提交准入材料', noLayout: true },
    component: () => import('../views/pc-submit-material.vue')
  },
  {
    path: '/market-access-mgmt/pc-status',
    name: 'market-access-mgmt-pc-status',
    meta: { title: '准入申请状态', noLayout: true },
    component: () => import('../views/pc-status.vue')
  }
];

export const route = [...industryRoutes, ...aspRoutes, ...pcRoutes];
